namespace Nobox.Nobox {
    export interface CampaignForm {
        Name: Serenity.StringEditor;
        Status: CampaignStatus;
        ChannelId: Serenity.ServiceLookupEditor;
        ChannelNm: Serenity.StringEditor;
        AccountIds: Serenity.ServiceLookupEditor;
        ListIds: Serenity.ServiceLookupEditor;
        Groups: Serenity.ServiceLookupEditor;
        Tags: Serenity.ServiceLookupEditor;
        Subject: Serenity.StringEditor;
        DvsId: Serenity.ServiceLookupEditor;
        BodyType: Serenity.EnumEditor;
        ShortLink: Serenity.BooleanEditor;
        GenerateMessage: Serenity.IntegerEditor;
        toolbarTextArea: Serenity.Extensions.StaticTextBlock;
        BodyText: Serenity.TextAreaEditor;
        Body: Serenity.HtmlContentEditor;
        Button: Serenity.StringEditor;
        ButtonClose: Serenity.Extensions.StaticTextBlock;
        Button1: Serenity.StringEditor;
        Button1Close: Serenity.Extensions.StaticTextBlock;
        Button1CloseHide: Serenity.Extensions.StaticTextBlock;
        Button2: Serenity.StringEditor;
        Button2Close: Serenity.Extensions.StaticTextBlock;
        ButtonCreate: Serenity.Extensions.StaticTextBlock;
        ButtonActType: TypeActionButton;
        ButtonActText: Serenity.StringEditor;
        ButtonAct: Serenity.StringEditor;
        ButtonActClose: Serenity.Extensions.StaticTextBlock;
        ButtonAct1Type: TypeActionButton;
        ButtonAct1Text: Serenity.StringEditor;
        ButtonAct1: Serenity.StringEditor;
        ButtonAct1Close: Serenity.Extensions.StaticTextBlock;
        ButtonActCreate: Serenity.Extensions.StaticTextBlock;
        ListMessage: Serenity.Extensions.StaticTextBlock;
        Attachment: Serenity.MultipleImageUploadEditor;
        IsPerContact: Serenity.BooleanEditor;
        PerDay: PerDayCampaign;
        Start: CustomDatePickerEditor;
        End: CustomDatePickerEditor;
        IsSchedule: Serenity.BooleanEditor;
        Schedule: CustomDateTimeEditor;
        Desc: Serenity.TextAreaEditor;
        DataExcel: Serenity.ImageUploadEditor;
        DataLookupBy: CampaignDataLookupBy;
        ColumnExcel: ExcelColumnEditor;
        InteractiveMsg: Serenity.StringEditor;
    }

    export class CampaignForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Campaign';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CampaignForm.init)  {
                CampaignForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = CampaignStatus;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.Extensions.StaticTextBlock;
                var w7 = s.TextAreaEditor;
                var w8 = s.HtmlContentEditor;
                var w9 = TypeActionButton;
                var w10 = s.MultipleImageUploadEditor;
                var w11 = PerDayCampaign;
                var w12 = CustomDatePickerEditor;
                var w13 = CustomDateTimeEditor;
                var w14 = s.ImageUploadEditor;
                var w15 = CampaignDataLookupBy;
                var w16 = ExcelColumnEditor;

                Q.initFormType(CampaignForm, [
                    'Name', w0,
                    'Status', w1,
                    'ChannelId', w2,
                    'ChannelNm', w0,
                    'AccountIds', w2,
                    'ListIds', w2,
                    'Groups', w2,
                    'Tags', w2,
                    'Subject', w0,
                    'DvsId', w2,
                    'BodyType', w3,
                    'ShortLink', w4,
                    'GenerateMessage', w5,
                    'toolbarTextArea', w6,
                    'BodyText', w7,
                    'Body', w8,
                    'Button', w0,
                    'ButtonClose', w6,
                    'Button1', w0,
                    'Button1Close', w6,
                    'Button1CloseHide', w6,
                    'Button2', w0,
                    'Button2Close', w6,
                    'ButtonCreate', w6,
                    'ButtonActType', w9,
                    'ButtonActText', w0,
                    'ButtonAct', w0,
                    'ButtonActClose', w6,
                    'ButtonAct1Type', w9,
                    'ButtonAct1Text', w0,
                    'ButtonAct1', w0,
                    'ButtonAct1Close', w6,
                    'ButtonActCreate', w6,
                    'ListMessage', w6,
                    'Attachment', w10,
                    'IsPerContact', w4,
                    'PerDay', w11,
                    'Start', w12,
                    'End', w12,
                    'IsSchedule', w4,
                    'Schedule', w13,
                    'Desc', w7,
                    'DataExcel', w14,
                    'DataLookupBy', w15,
                    'ColumnExcel', w16,
                    'InteractiveMsg', w0
                ]);
            }
        }
    }
}
